<!--
	* @Description: 办公制章管理 详情
	* @Author: ZSC
	* @Date: 2023-04-18 15:51:22.290
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-04-18 16:10:38
-->
<template>
	<div>
		<el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
			<template #header>
				<div class="header-left">
					<el-icon class="header-icon"><Document /></el-icon>
					<span class="header-title">详情</span>
				</div>
				<div class="header-right">
					<el-button type="info" text @click="closeWindow('openDetail', emits, false)">
						<el-icon><Close /></el-icon>
					</el-button>
				</div>
			</template>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="公章编号" label-align="right" align="left" width="120px" span="2">{{ruleForm.gzbh}}</el-descriptions-item>
				<el-descriptions-item label="制章名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.zzmc}}</el-descriptions-item>
				<el-descriptions-item label="保管单位名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.bgdwmc}}</el-descriptions-item>
				<el-descriptions-item label="保管人" label-align="right" align="left" width="120px" span="2">{{ruleForm.bgrxm}}</el-descriptions-item>
				<el-descriptions-item label="批准单位" label-align="right" align="left" width="120px" span="2">{{ruleForm.pzdw}}</el-descriptions-item>
				<el-descriptions-item label="批准人" label-align="right" align="left" width="120px" span="2">{{ruleForm.pzrxm}}</el-descriptions-item>
				<el-descriptions-item label="批准文号" label-align="right" align="left" width="120px" span="2">{{ruleForm.pzwh}}</el-descriptions-item>
				<el-descriptions-item label="批准日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.pzrq}}</el-descriptions-item>
				<el-descriptions-item label="生效日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.sxrq}}</el-descriptions-item>
				<el-descriptions-item label="作废批准文号" label-align="right" align="left" width="120px" span="2">{{ruleForm.zfpzwh}}</el-descriptions-item>
				<el-descriptions-item label="作废日期" label-align="right" align="left" width="120px" span="2">{{ruleForm.zfrq}}</el-descriptions-item>
				<el-descriptions-item label="作废批准人" label-align="right" align="left" width="120px" span="2">{{ruleForm.zfpzrxm}}</el-descriptions-item>
				<!-- <el-descriptions-item label="印章图样" label-align="right" align="left" width="120px" span="2">{{ruleForm.yzty}}</el-descriptions-item> -->
			</el-descriptions>
			<template #footer>
				<div class="dialog-footer">
					<div></div>
					<div class="footer_but">
						<el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
	() => props.openDetail,
	() => {
		if (props.openDetail) {
			loadData({
				url: '/api/v2/bangong/bangongzhizhangguanli/' + props.row.id,
				ruleForm,
				loadSuccess: function (res) {

				}
			})
		}
	}, { deep: true, immediate: true })
</script>
